import type { ComponentProps } from 'react';
import { modalRenderer } from '~/modal/modalRendererRegistry';
import { DataLayerUpgradeModalContainer } from './dataLayerUpgradeModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    DataLayerUpgrade: ComponentProps<typeof DataLayerUpgradeModalContainer>;
  }
}

modalRenderer.register('DataLayerUpgrade', DataLayerUpgradeModalContainer);
